import { useTranslation } from "react-i18next";
import { Search } from "lucide-react";
import { Text } from "components/text";

export const BooksTableNoResults = ({ query }: { query?: string }) => {
  const { t } = useTranslation(["components"]);

  return (
    <div
      data-testid="no-results"
      className="flex min-h-80 flex-col items-center justify-center rounded-xl border border-secondary-200 bg-white px-6 py-12 text-center"
    >
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-secondary-50 text-secondary-500">
        <Search aria-hidden="true" className="h-5 w-5" />
      </div>
      <Text as="h3" variant="heading">
        {query
          ? t("components:booksTable.noResults.titleWithQuery", { query })
          : t("components:booksTable.noResults.title")}
      </Text>
      <Text variant="muted" className="mt-2 max-w-2xl">
        {t("components:booksTable.noResults.description")}
      </Text>
    </div>
  );
};
